function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 71.718v-33.46m12 46.615v-59.77m12 69.72V14.34m12 15.547v51.016m12 21.502V8.36m12 102.065V.606m12 98.665V10.753m12 75.866V22.711m12 7.176v51.016m12 11.994v-74.97m12 66.635V26.3m12 43.075V40.65m-126 31.07V38.257m12 46.615v-59.77m12 69.72V14.34m12 15.547v51.016m12 21.502V8.36m12 102.065V.606m12 98.665V10.753m12 75.866V22.711m12 7.176v51.016m12 11.994v-74.97m12 66.635V26.3m12 43.075V40.65M.5 65.045V44.237m6 20.808V44.237",
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF",
  strokeLinecap: "round"
});

function SvgRoomNoise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151,
    height: 111,
    viewBox: "0 0 151 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomNoise);
export default __webpack_public_path__ + "static/media/RoomNoise.5cd451dd.svg";
export { ForwardRef as ReactComponent };